import { InputNumber, Table, Tooltip } from 'antd';
import Column from 'antd/es/table/Column';
import ColumnGroup from 'antd/es/table/ColumnGroup';
import { ArcElement, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Tooltip as ChartTooltip } from 'chart.js';
import React from 'react';
import { Link } from 'react-router-dom';
import { trangThaiKPI } from '../../constants';
import { Links } from '../../helpers/Links';
import { KPIDuyetResponse } from '../../models/kpi/KPICaNhan';
import DiemPheDuyetSelectBox from '../utils/DiemPheDuyetSelectBox';
import { getDiemDanhGiaByDiemXepLoai, getDiemXepLoaiByDiemDanhGia, getXepLoai, getXepLoaiByDiemDanhGia } from './kpiHelper';
import { useSelector } from 'react-redux';
ChartJS.register(ArcElement, ChartTooltip, Legend, CategoryScale, LinearScale, BarElement);

interface Props {
    data: any[];
    isLoadingTable: boolean;
    tongHopKPI: any;
    hideSelection: boolean;
    selectedRowKeys: React.Key[];
    onSelectedRowKeysChange: any;
    selectRow: (record: any) => void;
    setData: (data: any[]) => void;
    layClassName: (record: any) => string;
    titleTongSoLoi?: string;
    tongSoLoiWidth?: number | string;
}

const DuyetKPIGiamDocTable = ({
    data,
    isLoadingTable,
    hideSelection = false,
    tongHopKPI,
    selectedRowKeys,
    onSelectedRowKeysChange,
    selectRow,
    setData,
    layClassName,
    titleTongSoLoi = "Tổng số lỗi trong năm",
    tongSoLoiWidth,
}: Props) => {
    const user = useSelector((state: any) => state.auth.currentUser);
    return (
        <Table
            loading={isLoadingTable}
            locale={{ emptyText: "Không có dữ liệu" }}
            dataSource={data}
            rowSelection={!hideSelection && (tongHopKPI != null && data?.some((record) => record.trangThai === trangThaiKPI.trinhLanhDaoDonVi || (record.trangThai === trangThaiKPI.khoiTao && record.idNhanVien == user.idNhanVien))) ?
                {
                    type: "checkbox",
                    columnWidth: "25px",
                    selectedRowKeys,
                    onChange: onSelectedRowKeysChange,
                    getCheckboxProps: (record: KPIDuyetResponse) => ({
                        disabled: !(record.trangThai == trangThaiKPI.trinhLanhDaoDonVi || (record.trangThai === trangThaiKPI.khoiTao && record.idNhanVien == user.idNhanVien)),
                    }),
                } : undefined
            }
            onRow={(record) => ({
                onClick: () => {
                    selectRow(record);
                },
            })}
            pagination={false}
            sticky
            scroll={{ x: 1200 }}
        >
            <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" width="200px" fixed />
            <Column title="Chức vụ" dataIndex="tenChucVu" key="tenChucVu" fixed />
            <ColumnGroup title="Cá nhân tự xếp loại" key="canhan">
                <Column title="Tổng điểm" align="center" dataIndex="tuDanhGia" key="tuDanhGia" />
                <Column title="Xếp loại" align="center" dataIndex="tuDanhGia" key="tuDanhGiaXL" render={(value: any, record: any) => {
                    return record.tuDanhGia != null ? getXepLoaiByDiemDanhGia(record.tuDanhGia, record.tuDanhGiaCM) : "";
                }} />
            </ColumnGroup>
            <ColumnGroup title="Xếp loại của LĐ phòng nghiệp vụ" key="ldpnv">
                <Column title="Tổng điểm" align="center" dataIndex="lanhDaoPhong" key="lanhDaoPhong" />
                <Column title="Xếp loại" align="center" dataIndex="lanhDaoPhong" key="lanhDaoPhongXL" render={(value: any, record: any) => {
                    return record.lanhDaoPhong != null ? getXepLoaiByDiemDanhGia(record.lanhDaoPhong, record.lanhDaoPhongCM) : "";
                }} />
            </ColumnGroup>
            <ColumnGroup title="Ý kiến của Phó Giám đốc" key="pgd">
                <Column title="Tổng điểm" align="center" dataIndex="lanhDaoPhuTrach" key="lanhDaoPhuTrach" />
                <Column title="Xếp loại" align="center" dataIndex="lanhDaoPhuTrach" key="lanhDaoPhuTrachXL" render={(value: any, record: any) => {
                    return record.lanhDaoPhuTrach != null ? getXepLoaiByDiemDanhGia(record.lanhDaoPhuTrach, record.lanhDaoPhuTrachCM) : "";
                }} />
            </ColumnGroup>
            <Column title="Điểm cộng" width="74px" dataIndex="diemCong" key="diemCong" align="center"
                render={(_, i) => i.lanhDaoPhuTrachDiemCong > 0 ? i.lanhDaoPhuTrachDiemCong : i.lanhDaoPhongDiemCong > 0 ? i.lanhDaoPhongDiemCong : i.tuDanhGiaDiemCong}
            />
            <ColumnGroup title="Phê duyệt của Giám đốc" key="gd">
                <Column
                    title="Tổng điểm"
                    dataIndex="diemDanhGia" align="center"
                    key="diemDanhGia"
                    onCell={() => ({ onClick: (e) => e.stopPropagation() })}
                    render={(_, record: any, index: number) => {
                        const { trangThai, diemDanhGia, lanhDaoPhuTrach, lanhDaoPhong, tuDanhGia, idNhanVien, tuDanhGiaCM, lanhDaoPhongCM, lanhDaoPhuTrachCM } = record;
                        const defaultInputVal = diemDanhGia ?? lanhDaoPhuTrach ?? lanhDaoPhong ?? tuDanhGia;
                        const diemChuyenMon = lanhDaoPhuTrachCM > 0 ? lanhDaoPhuTrachCM : lanhDaoPhongCM > 0 ? lanhDaoPhongCM : tuDanhGiaCM;
                        if (trangThai == trangThaiKPI.trinhLanhDaoDonVi || (trangThai == trangThaiKPI.khoiTao && idNhanVien == user.idNhanVien)) {
                            return (<InputNumber
                                style={{ width: "100%" }}
                                value={defaultInputVal}
                                className="hide-arrow"
                                key={index}
                                onChange={(value: any) => {
                                    const giaTri = value ?? 0;
                                    record.diemDanhGia = giaTri;
                                    record.lanhDaoDonVi = getDiemXepLoaiByDiemDanhGia(giaTri, diemChuyenMon);
                                    setData([...data]);
                                }}
                            />);
                        }

                        return diemDanhGia;
                    }}
                />

                <Column
                    title="Xếp loại"
                    dataIndex="lanhDaoDonVi"
                    key="lanhDaoDonVi"
                    align="center"
                    onCell={() => ({ onClick: (e) => e.stopPropagation() })}
                    render={(_, record: any) => {
                        const { trangThai, lanhDaoDonVi, lanhDaoPhuTrach, lanhDaoPhong, tuDanhGia, diemDanhGia, idNhanVien, tuDanhGiaCM, lanhDaoPhongCM, lanhDaoPhuTrachCM } = record;
                        const defaultSelectVal = lanhDaoDonVi ?? getDiemXepLoaiByDiemDanhGia(lanhDaoPhuTrach ?? lanhDaoPhong ?? tuDanhGia, lanhDaoPhuTrachCM ?? lanhDaoPhongCM ?? tuDanhGiaCM);
                        const diemChuyenMon = lanhDaoPhuTrachCM > 0 ? lanhDaoPhuTrachCM : lanhDaoPhongCM > 0 ? lanhDaoPhongCM : tuDanhGiaCM;

                        if (trangThai == trangThaiKPI.trinhLanhDaoDonVi || (trangThai == trangThaiKPI.khoiTao && idNhanVien == user.idNhanVien)) {
                            return (
                                <DiemPheDuyetSelectBox
                                    value={defaultSelectVal}
                                    diemChuyenMon={diemChuyenMon}
                                    onChange={(e: any) => {
                                        const selectedVal = e.target.value;
                                        record.lanhDaoDonVi = selectedVal;
                                        const fallbackScore = diemDanhGia ?? lanhDaoPhuTrach ?? lanhDaoPhong ?? tuDanhGia;
                                        const currentDiemXepLoai = getDiemXepLoaiByDiemDanhGia(fallbackScore, diemChuyenMon);
                                        record.diemDanhGia = selectedVal !== currentDiemXepLoai
                                            ? getDiemDanhGiaByDiemXepLoai(selectedVal)
                                            : fallbackScore;

                                        setData([...data]);
                                    }}
                                />
                            );
                        }

                        return getXepLoai(lanhDaoDonVi);

                    }}
                />
            </ColumnGroup>
            <Column title="Tổng số lỗi trong năm" dataIndex="tongSoLoi" key="tongSoLoi" align="center" />
            <Column title="" dataIndex="action" key="action"
                fixed='right'
                onCell={(record, rowIndex) => {
                    return {
                        onClick: (event) => {
                            event.stopPropagation();
                        },
                    };
                }}
                render={(value: any, record: any) => {
                    const btn = <Link key={record.idKPICaNhan} target="_blank" rel="noopener noreferrer" className={"hrm-btn hrm-btn-sm " + layClassName(record)} to={Links.KPI.ChiTietKPI + "?id=" + record.idKPICaNhan}>Xem</Link>;
                    if (!record.yKien) {
                        return btn;
                    }
                    return <Tooltip
                        title={<span style={{ whiteSpace: 'pre-wrap' }}>{record.yKien}</span>}
                        overlayStyle={{ maxWidth: 400 }}
                    >
                        {btn}
                    </Tooltip>;
                }}
            />
        </Table>
    );
};

export default DuyetKPIGiamDocTable;